<div class="inactivity-warning-container">
    <div class="warning-message">
        <span>Your session will expire in <strong>{{ countdownDisplay() }}</strong> due to inactivity.</span>
    </div>
    <button mat-raised-button color="primary" (click)="onStayLoggedIn()">
        Stay Logged In
    </button>
</div>